

const splitUid = (uid: string): [number, number] => {
  if(!uid) {
    return [0, 0];
  }
  const r = uid.split(':');
  if(r.length !== 2) {
    throw new Error('Invalid UID');
  }
  return [
    parseInt(r[0]),
    parseInt(r[1])
  ];
}

export enum EntityType {
  SHIPS = 2,
  VEHICLES = 3,
  FACILITIES = 4,
  STATIONS = 5,
  CITIES = 7,
  PLANETS = 8,
  SYSTEMS = 9,
  NPCS = 10,
  CREATURES = 11,
  ITEMS = 12,
  DROIDS = 13,
  MATERIALS = 16
}


export const getTypeFromUID = (uid: string) => splitUid(uid)[0];
export const getTypeNameFromUID = (uid: string) => {
  const id = getTypeFromUID(uid);
  return EntityType[id];
};


